export const common = {
    // Navigation
    nav: {
        home: 'Inicio',
        products: 'Productos',
        about: 'Acerca de',
        contact: 'Contacto',
        cart: 'Carrito',
        account: 'Cuenta',
    },
    // Actions
    actions: {
        add: 'Añadir',
        remove: 'Eliminar',
        edit: 'Editar',
        delete: 'Eliminar',
        create: 'Crear',
        save: 'Guardar',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
        search: 'Buscar',
        filter: 'Filtrar',
        sort: 'Ordenar',
        apply: 'Aplicar',
        clear: 'Limpiar',
        back: 'Volver',
        next: 'Siguiente',
        previous: 'Anterior',
        submit: 'Enviar',
        loading: 'Cargando...',
        close: 'Cerrar',
    },
    // Messages
    messages: {
        success: 'Operación realizada con éxito',
        error: 'Ocurrió un error',
        notFound: 'No encontrado',
        unauthorized: 'No autorizado',
        forbidden: 'Acceso denegado',
        validationError: 'Error de validación',
        networkError: 'Error de conexión',
        tryAgain: 'Intentar de nuevo',
    },
    // Form labels
    form: {
        email: 'Correo electrónico',
        password: 'Contraseña',
        name: 'Nombre',
        phone: 'Teléfono',
        address: 'Dirección',
        city: 'Ciudad',
        state: 'Estado',
        zip: 'Código postal',
        country: 'País',
        required: 'Obligatorio',
        optional: 'Opcional',
    },
    // Common terms
    common: {
        price: 'Precio',
        quantity: 'Cantidad',
        total: 'Total',
        subtotal: 'Subtotal',
        shipping: 'Envío',
        discount: 'Descuento',
        free: 'Gratis',
        outOfStock: 'Sin stock',
        inStock: 'En stock',
        available: 'Disponible',
        unavailable: 'No disponible',
        allRightsReserved: 'Todos los derechos reservados',
    },
};
//# sourceMappingURL=common.js.map